import { gql } from '@apollo/client';

export const FORGOT_PASSWORD = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;
